const API_URL = import.meta.env.VITE_API_URL;
const isDev = import.meta.env.DEV;
const customerEntryEndpoint = isDev
  ? "/FairCustomer/customerEntryNew"
  : "/FairCustomer/customerEntry";

window.addEventListener("message", async (event) => {
  if (!event.data || !event.data.url) return;
  const url = new URL(event.data.url);
  const searchParams = new URLSearchParams(url.search);

  const knownKeys = [
    "click_id",
    "utm_source",
    "utm_campaign",
    "utm_listpublisher",
    "sourceID",
    "utm_medium",
  ];

  const data: { [key: string]: string } = {
    ClientVersion: "2.0",
    EventName: "PageLoad",
    CarEdgePurchaseStep: `${url.host}${url.pathname}`, // fallback
  };

  knownKeys.forEach((key) => {
    const value = searchParams.get(key);
    if (value) {
      data[key] = value;
    }
  });

  const unknownParams: { key: string; value: string }[] = [];
  for (const [key, value] of searchParams.entries()) {
    if (!knownKeys.includes(key)) {
      unknownParams.push({ key, value });
    }
  }

  if (unknownParams[0]) {
    data["UTM_1_name"] = unknownParams[0].key;
    data["UTM_1_data"] = unknownParams[0].value;
  }
  if (unknownParams[1]) {
    data["UTM_2_name"] = unknownParams[1].key;
    data["UTM_2_data"] = unknownParams[1].value;
  }
  if (unknownParams[2]) {
    data["UTM_3_name"] = unknownParams[2].key;
    data["UTM_3_data"] = unknownParams[2].value;
  }

  if (unknownParams.length > 3) {
    const overflow: { [key: string]: string } = {};
    unknownParams.slice(3).forEach((param) => {
      overflow[param.key] = param.value;
    });
    data["OverflowUTM"] = JSON.stringify(overflow);
  }

  const ipResponse = await fetch(`https://ipapi.co/json/`);
  const ipInfo = await ipResponse.json();

  fetch(`${API_URL}${customerEntryEndpoint}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      ...data,
      UserBrowserIP: ipInfo.ip,
      UserBrowserCity: ipInfo.city,
      UserBrowserRegionCode: ipInfo.region_code,
      UserBrowserLat: ipInfo.latitude,
      UserBrowserLong: ipInfo.longitude,
    }),
  });
});
